// extracted by mini-css-extract-plugin
export default {"base--default":"SSHException_base--default__RZNE8","subtitle2--invalid":"SSHException_subtitle2--invalid__OvkGI"};